export const EVENT_ADD_WAITING_ASSET = 'EVENT_ADD_WAITING_ASSET';
